import React, { useState, useEffect } from "react";
import { Menu, Icon, Segment } from "semantic-ui-react";

import {
  Container,
  Label,
  ContainerResolve
} from "./styled";
import { producaov2 as api } from "../../../../services/apis";
import { useRouter } from "../../../../hooks/router";
import DuvidasNovo from "../DuvidasNovo";
import ControleEnviosNovo from "../../ControleEnviosNovo";
import ControleProjetoNovo from "../../ControleProjetosNovo";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { MainContainer } from "./styled";
import ProjectApplications from "../../ProjectApplications";
import DuvidasV3 from "../DuvidasV3";

function Operacoes() {
  let opcao = 1;
  const [activeItem, setActiveItem] = useState(1);
  const router = useRouter();
  

  const handleItemClick = (option) => {
    opcao = option;
    setActiveItem(option);
  };

  useEffect(async () => {
    try {
      let logs = { local: "operacoes", texto: `listou as operações` };
      await api.post("system_logs", { acao: JSON.stringify(logs) });
    } catch (err) {
      console.error("ERRO", err);
    }
  }, []);

  useEffect(() => {
    const { hash } = router?.location;

    const tab = ["ppa", "envios","duvidas", "projetos"].find(
      tab => tab === hash.toLowerCase().replace("#", "")
    );


    if (!tab) {
      return;
    }

    if(tab == "duvidas"){
      setActiveItem(1)
      return;
    }
    if(tab == "envios"){
      setActiveItem(2)
      return;
    }
    if(tab == "projetos" || tab == "ppa"){
      setActiveItem(3);

      return;
    }
    
  }, [router]);


  const renderTab = () => (
    <Segment attached="bottom">
      {/* {activeItem === 0 && (

        <>
          <ContainerResolve>
            <DuvidasNovo />
          </ContainerResolve>
        </>
      )
      } */}

      {activeItem === 1 && (

        <>
          <ContainerResolve>
            <DuvidasV3 />
          </ContainerResolve>
        </>
      )
      }

      {
        activeItem === 2 && (
          <>
            <ContainerResolve>
              <ControleEnviosNovo />
            </ContainerResolve>
          </>
        )
      }

      {
        activeItem === 3 && (
          <>
            <ControleProjetoNovo />
          </>
        )
      }

      {
        activeItem === 4 && (
          <>
            <ProjectApplications />
          </>
        )
      }
    </Segment>
  );

  return (
    <MainContainer>
      <AdminMenu />
      <Container>
        <h1>Painel de Operações</h1>
        <Menu attached="top" tabular>
          {/* <Menu.Item
            name="duvidas"
            active={activeItem === 0}
            onClick={() => handleItemClick(0)}
          >
            <Icon name="question mark icon" />
            <Label>Dúvidas</Label>
          </Menu.Item> */}

          <Menu.Item
            name="duvidas"
            active={activeItem === 1}
            onClick={() => handleItemClick(1)}
          >
            <Icon name="question mark icon" />
            <Label>Dúvidas (Novo)</Label>
          </Menu.Item>

          <Menu.Item
            name="envios"
            active={activeItem === 2}
            onClick={() => handleItemClick(2)}
          >
            <Icon name="quote left icon" />
            <Label>Envios</Label>
          </Menu.Item>

          <Menu.Item
            name="projetos"
            active={activeItem === 3}
            onClick={() => handleItemClick(3)}
          >
            <Icon name="file alternate outline icon" />
            <Label>Acompanhamento de aplicações (Legado)</Label>
          </Menu.Item>

          <Menu.Item
            name="projetos"
            active={activeItem === 4}
            onClick={() => handleItemClick(4)}
          >
            <Icon name="file alternate outline icon" />
            <Label>Acompanhamento de aplicações</Label>
          </Menu.Item>
        </Menu>

        {renderTab()}
      </Container>
    </MainContainer>
  );
}

export default Operacoes;
